import { render, staticRenderFns } from "./PassOrderNotice.vue?vue&type=template&id=269a6991&scoped=true"
import script from "./PassOrderNotice.vue?vue&type=script&lang=js"
export * from "./PassOrderNotice.vue?vue&type=script&lang=js"
import style0 from "./PassOrderNotice.vue?vue&type=style&index=0&id=269a6991&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269a6991",
  null
  
)

export default component.exports